// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fcis-vehicle-detail__spec{display:block}.fcis-vehicle-detail__icon{width:16px;height:16px;margin-right:var(--wb-spacing-3xs);color:var(--wb-grey-60)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
